import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, CanActivate } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { VerifyTokenGuard } from 'src/app/shared/guard/verify-token.guard';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { StoreService } from 'src/app/shared/resolvers/store.service';
import { FeatureTagResolver } from 'src/app/shared/resolvers/feature-tag.resolver';
import { ProductDialogComponent } from 'src/app/shared/products-carousel/product-dialog/product-dialog.component';
import { MenuService } from 'src/app/shared/resolvers/menu.service';
import { ProductGuard } from 'src/app/shared/guard/product.guard';
import { NgxImageZoomModule } from 'ngx-image-zoom';

import { RedirectGuard } from '../global-theme/redirect-route.service';
import { ProductsComponent } from '../global-theme/pages/products/products.component';
import { ProductZoomComponent } from '../global-theme/pages/products/product/product-zoom/product-zoom.component';
import { CategoriesComponent } from '../global-theme/pages/products/categories/categories.component';
import { HomeComponent } from '../global-theme/pages/home/home.component';
import { LittleFarmProductComponent } from './product/product.component';
import { ProductsModule } from '../global-theme/pages/products/products.module';


export const LITTLE_FARM_PROD_ROUTES = [  
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'categories',
  },
  {
    path: 'products', component: ProductsComponent, pathMatch: 'full',
    data: { breadcrumb: 'All Products', title: 'All Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'categories', component: ProductsComponent, pathMatch: 'full',
    resolve: { store: StoreService, featureTags: FeatureTagResolver },
    data: { title: 'All Categories' }, 
    canActivate: [ProductGuard],
  },
  {
    path: 'categories/:parentCategory', component: ProductsComponent,
    data: { title: 'Products' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: "producers/:vendor_url",
    component: ProductsComponent,
    data: { title: "Producers" },
    canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: "producers/:parentCategory/:subCategory",
    component: ProductsComponent,
    data: { title: "Producers" },
    canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },

  {
    path: 'producers/:parentCategory/:subCategory/:productName/:code', component: LittleFarmProductComponent,
    data: { title: 'Producers' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'producers/:parentCategory/:subCategory/:code', component: LittleFarmProductComponent,
    data: { title: 'Producers' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'categories/:parentCategory/:productName/:code', component: LittleFarmProductComponent,
    data: { title: 'Products' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'categories/:parentCategory/:subCategory', component: ProductsComponent,
    data: { title: 'Products' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'categories/:parentCategory/:subCategory/:productName/:code', component: LittleFarmProductComponent,
    data: { title: 'Products' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'categories/:parentCategory/:subCategory/:code', component: LittleFarmProductComponent,
    data: { title: 'Products' }, canActivate: [ProductGuard],
    resolve: { featureTags: FeatureTagResolver},
  },
  {
    path: 'product/:productName/:code', component: LittleFarmProductComponent,
    data: { title: 'Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'products/:code', component: LittleFarmProductComponent,
    data: { title: 'Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'products/search/:category', component: ProductsComponent,
    data: { title: 'Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'products', component: ProductsComponent,
    data: { title: 'All Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'previously-ordered', component: ProductsComponent,
    data: { title: 'Previously Ordered' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'product-dialog', component: ProductDialogComponent,
    canActivate: [VerifyTokenGuard, AuthGuard],
    data: { title: 'Products' },
    resolve: { featureTags: FeatureTagResolver },
  },
  {
    path: 'shop', component: ProductsComponent,
    data: { title: 'Shop' },
    resolve: { featureTags: FeatureTagResolver },
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    NgxPaginationModule,
    SharedModule,
    PipesModule,
    NgxImageZoomModule,
    RouterModule.forChild(LITTLE_FARM_PROD_ROUTES),
  ],
  declarations: [
  ],
  entryComponents: [
    ProductZoomComponent
  ],
  providers:[
    FeatureTagResolver,
  ]
})
export class LittleFarmProductsModule { }